import pixlee from 'services/api/gallery/pixlee';

const { setLoveMedia, deleteLoveMedia, deleteContent } = pixlee;

export default {
    setLoveMedia,
    deleteLoveMedia,
    deleteContent
};
